import React from 'react';
import { cn } from '../../lib/cn';
export function StatCard({
  label,
  value,
  hint,
  tone = 'neutral'
}: {
  label: string;
  value: string;
  hint?: string;
  tone?: 'neutral' | 'pos' | 'neg';
}) {
  return <div className="rounded-2xl border border-line bg-white p-4 shadow-card" data-id="element-279" data-mp="1ekeianvir5rt">
      <p className="text-[12px] font-medium text-ink-soft" data-id="element-280" data-mp="1jiy50qhxsll8">{label}</p>
      <p className={cn('mt-1.5 text-2xl font-semibold tracking-tight tabular-nums', tone === 'pos' && 'text-pos', tone === 'neg' && 'text-neg', tone === 'neutral' && 'text-ink')} data-id="element-281" data-mp="1jk99ksj7hxde">
        {value}
      </p>
      {hint && <p className="mt-0.5 text-[12px] text-ink-soft" data-id="element-282" data-mp="vrkbih81ujyo">{hint}</p>}
    </div>;
}